module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu table"
  }, [_c('div', {
    staticClass: "tb-cell"
  }), _vm._v(" "), _c('div', {
    staticClass: "tb-cell fix"
  }, [_c('span', [_vm._v("云在飞的导航页")]), _vm._v(" "), _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "id": "login"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("设置")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tb-cell"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://yunzaifei.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("博客")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/yunzaifei",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/yunzaifei/vue-navweb",
      "target": "_blank"
    }
  }, [_vm._v("帮助")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41550184"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 73
// module chunks = 1